"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BackToQueueRequestStruct = void 0;
const superstruct_1 = require("superstruct");
exports.BackToQueueRequestStruct = (0, superstruct_1.type)({
    placeId: (0, superstruct_1.string)(),
    appointmentId: (0, superstruct_1.string)(),
    targetQueueId: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    counterId: (0, superstruct_1.optional)((0, superstruct_1.string)()),
});
//# sourceMappingURL=BackToQueueRequest.js.map